/**
 * The Asia/Jakarta (WIB, UTC+7) calendar day of a moment, as `YYYY-MM-DD`.
 *
 * The park is in Bandung and every operating day is a WIB day, but a browser building
 * `new Date().toISOString().slice(0, 10)` reports the UTC day — which for the first seven
 * hours of every WIB day is YESTERDAY. A visitor opening the app at 06:00 in Bandung
 * would be shown the previous day’s catalogue, and a date input whose `min` is "today"
 * would let them pick a day already past.
 *
 * `en-CA` formats as `YYYY-MM-DD`, which is the shape every date input and API parameter
 * wants, so no manual assembly is needed.
 */
const WIB_DATE = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Jakarta",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function jakartaDateKey(value: string | number | Date = new Date()): string {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return WIB_DATE.format(new Date());
  return WIB_DATE.format(d);
}

/** Today, in the park’s timezone. */
export const todayInJakarta = (): string => jakartaDateKey(new Date());
